export const heroData = {
  title: "Delete your digital footprint.",
  subtitle: "Press the download button to start your download.",
  downloadText: "Available for Windows, MacOS, and Linux today",
};
export const pricingData = {
  title: "Download Redact today.",
  subtitle:
    "We are frequently updating support to other social network services. You can receive direct updates from us in our Discord Channel.",
};
